import React, { useState } from "react";
import {
  ArrowLeft,
  ArrowRight,
  Building2,
  Home,
  Building,
} from "lucide-react";
import { useNavigate } from "react-router-dom";

const ChooseAccount = ({ onSelectRole, onBack }) => {
  const [selectedRole, setSelectedRole] = useState(null);
  const navigate = useNavigate()

  const handleContinue = () => {
    if (!selectedRole) return;
    if(selectedRole === "customer"){
      navigate("/customer/register/personalInfo");
    }else{
      navigate("/agent/register/personalInfo");
    }
    if (onSelectRole) {
      onSelectRole(selectedRole);
    }
  };

  const handleRoleSelect = (role) => {
    setSelectedRole(role);
  };

  return (
    <main className="min-h-screen w-full overflow-hidden bg-[#fdfbf5] text-[#1f2318]">
      <section className="mx-auto flex min-h-screen w-full overflow-hidden bg-white lg:grid lg:grid-cols-[55.5%_44.5%]">

        {/* =====================================================
            LEFT — SAME TERRA LOGIN DESIGN
        ====================================================== */}
        <div className="relative hidden min-h-screen overflow-hidden lg:block">
          <img
            src="https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=1600&q=85"
            alt="Modern UAE real estate property"
            className="absolute inset-0 h-full w-full object-cover"
          />

          <div className="absolute inset-0 bg-gradient-to-b from-[#1b2815]/10 via-[#172114]/20 to-[#172114]/80" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#172114]/20 via-transparent to-transparent" />

          {/* Terra */}
          <div className="absolute left-8 top-8 z-10 flex items-center gap-2 sm:left-10 sm:top-9">
            <div className="flex h-8 w-8 items-center justify-center rounded-lg border border-white/35 bg-white/15 text-white backdrop-blur-md">
              <Building2 size={15} strokeWidth={2.2} />
            </div>
            {/* <span className="text-[14px] font-semibold tracking-[-0.01em] text-white">
              Terra
            </span> */}
          </div>

          {/* UAE badge */}
          <div className="absolute right-8 top-8 z-10 rounded-full border border-white/25 bg-white/10 px-3 py-1.5 text-[9px] font-semibold uppercase tracking-[0.12em] text-white backdrop-blur-md sm:right-10 sm:top-9">
            UAE Real Estate
          </div>

          {/* Hero content */}
          <div className="absolute bottom-7 left-8 right-8 z-10 sm:bottom-9 sm:left-10 sm:right-10 lg:bottom-10">
            <div className="mb-2 text-[9px] font-bold uppercase tracking-[0.17em] text-[#dce8cf] sm:text-[10px]">
              CREATE YOUR UAE REAL ESTATE ACCOUNT
            </div>

            <h1 className="max-w-[650px] font-['Playfair_Display'] text-[38px] font-normal leading-[1.03] tracking-[-0.025em] text-white sm:text-[46px] lg:text-[48px]">
              Choose how you want
              <br />
              {/* <span className="italic font-medium">to use Terra.</span> */}
            </h1>

            <p className="mt-3 max-w-[470px] text-[11px] leading-[1.6] text-white/75 sm:text-[12px]">
              Select the account type that matches how you want to participate
              in the real estate platform.
            </p>

            <div className="mt-6 grid max-w-[500px] grid-cols-[1fr_auto_1fr_auto_1fr] items-center rounded-[12px] border border-white/15 bg-[#171e23]/60 px-3 py-2.5 backdrop-blur-xl sm:px-4 sm:py-3">
              <div className="text-center">
                <strong className="block text-[13px] font-semibold text-white">
                  AED
                </strong>
                <span className="mt-1 block text-[9px] uppercase tracking-[0.08em] text-white/50">
                  UAE currency
                </span>
              </div>

              <span className="h-7 w-px bg-white/15" />

              <div className="text-center">
                <strong className="block text-[13px] font-semibold text-white">
                  UAE
                </strong>
                <span className="mt-1 block text-[9px] uppercase tracking-[0.08em] text-white/50">
                  Property market
                </span>
              </div>

              <span className="h-7 w-px bg-white/15" />

              <div className="text-center">
                <strong className="block text-[13px] font-semibold text-white">
                  Digital
                </strong>
                <span className="mt-1 block text-[9px] uppercase tracking-[0.08em] text-white/50">
                  Account access
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* =====================================================
            RIGHT — ACCOUNT SELECTION
        ====================================================== */}
        <div className="relative flex min-h-screen w-full items-center justify-center bg-white px-7 py-12 sm:px-12 lg:px-14 xl:px-16">

          {/* Top-left back navigation */}
          <button
            type="button"
            onClick={() => navigate("/login")}
            aria-label="Back to login"
            className="absolute left-7 top-7 inline-flex items-center gap-2 rounded-full border border-[#e2e7de] bg-white px-3.5 py-2 text-[11px] font-semibold text-[#6f7468] shadow-[0_5px_18px_rgba(55,92,32,0.06)] transition hover:-translate-y-px hover:border-[#cddcbd] hover:bg-[#f7f9f4] hover:text-[#4c7a2e] sm:left-12 sm:top-9 lg:left-14"
          >
            <ArrowLeft size={14} />
            Back
          </button>

          <div className="w-full max-w-[430px] pt-10 sm:pt-6">

            <div className="mb-7 mt-10">
              <div className="mb-4 inline-flex rounded-full border border-[#cddcbd] bg-[#f0f6ea] px-3 py-1.5 text-[9px] font-semibold uppercase tracking-[0.14em] text-[#4c7a2e]">
                Create account
              </div>

              <h2 className="font-['Playfair_Display'] text-[31px] font-normal leading-[1.02] tracking-[-0.025em] text-[#183240] sm:text-[36px]">
                Choose your Account
                {/* <span className="block font-medium text-[#375c20]">
                  Terra account
                </span> */}
              </h2>

              <p className="mt-2 text-[11px] leading-[1.55] text-[#899087]">
                Choose your account type to get started.
              </p>
            </div>

            <div className="flex w-full flex-col gap-3">

              {/* Investor */}
              <button
                type="button"
                onClick={() => handleRoleSelect("customer")}
                className={`
                  group relative w-full rounded-[16px] border bg-white p-4 text-left
                  transition-all duration-200 hover:-translate-y-0.5
                  hover:shadow-[0_12px_30px_rgba(55,92,32,0.09)]
                  ${
                    selectedRole === "customer"
                      ? "border-[#8caf70] bg-[#fbfdf8] shadow-[0_7px_24px_rgba(76,122,46,0.11)]"
                      : "border-[#e1e6dc]"
                  }
                `}
              >
                <div className="flex gap-3.5">
                  <div
                    className={`
                      flex h-11 w-11 shrink-0 items-center justify-center rounded-[12px]
                      transition
                      ${
                        selectedRole === "customer"
                          ? "bg-[#e9f2e2] text-[#4c7a2e]"
                          : "bg-[#f3f6ef] text-[#6a7847]"
                      }
                    `}
                  >
                    <Home size={19} />
                  </div>

                  <div className="min-w-0 flex-1">
                    <div className="flex items-start justify-between gap-3">
                      <div>
                        <h3 className="m-0 text-[14px] font-bold text-[#26311f]">
                          Home Buyer / Investor
                        </h3>

                        <span className="mt-1 inline-flex rounded-full bg-[#edf5e7] px-2 py-0.5 text-[9px] font-semibold text-[#4c7a2e]">
                          Most popular
                        </span>
                      </div>

                      <ArrowRight
                        size={14}
                        className="mt-1 shrink-0 text-[#aeb6a5] transition group-hover:translate-x-0.5"
                      />
                    </div>

                    <p className="mt-2 mb-3 text-[11px] leading-[1.55] text-[#73786d]">
                      Browse listings, save favorites.
                    </p>

                    <div className="flex flex-wrap gap-1.5">
                      <span className="rounded-[6px] bg-[#f4f6f1] px-2 py-1 text-[9px] font-medium text-[#687062]">
                        Browse Properties
                      </span>
                      <span className="rounded-[6px] bg-[#f4f6f1] px-2 py-1 text-[9px] font-medium text-[#687062]">
                        Save Favorites
                      </span>
                      <span className="rounded-[6px] bg-[#f4f6f1] px-2 py-1 text-[9px] font-medium text-[#687062]">
                        Book Viewings
                      </span>
                    </div>
                  </div>
                </div>

                {selectedRole === "customer" && (
                  <div className="absolute bottom-3 right-3 flex h-5 w-5 items-center justify-center rounded-full bg-[#4c7a2e] text-white shadow-sm">
                    <span className="text-[10px]">✓</span>
                  </div>
                )}
              </button>

              {/* Property Owner */}
              <button
                type="button"
                onClick={() => handleRoleSelect("owner")}
                className={`
                  group relative w-full rounded-[16px] border bg-white p-4 text-left
                  transition-all duration-200 hover:-translate-y-0.5
                  hover:shadow-[0_12px_30px_rgba(55,92,32,0.09)]
                  ${
                    selectedRole === "owner"
                      ? "border-[#b5c994] bg-[#fbfdf8] shadow-[0_7px_24px_rgba(76,122,46,0.10)]"
                      : "border-[#e1e6dc]"
                  }
                `}
              >
                <div className="flex gap-3.5">
                  <div
                    className={`
                      flex h-11 w-11 shrink-0 items-center justify-center rounded-[12px]
                      transition
                      ${
                        selectedRole === "owner"
                          ? "bg-[#eef3e5] text-[#6a7847]"
                          : "bg-[#f6f7f2] text-[#7c846e]"
                      }
                    `}
                  >
                    <Building size={19} />
                  </div>

                  <div className="min-w-0 flex-1">
                    <div className="flex items-start justify-between gap-3">
                      <div>
                        <h3 className="m-0 text-[14px] font-bold text-[#26311f]">
                          Real Estate Agent / Property Owner
                        </h3>

                        <span className="mt-1 inline-flex rounded-full bg-[#f1f3e8] px-2 py-0.5 text-[9px] font-semibold text-[#6a7847]">
                          For professionals
                        </span>
                      </div>

                      <ArrowRight
                        size={14}
                        className="mt-1 shrink-0 text-[#aeb6a5] transition group-hover:translate-x-0.5"
                      />
                    </div>

                    <p className="mt-2 mb-3 text-[11px] leading-[1.55] text-[#73786d]">
                      List properties, manage clients, track leads, and grow
                      your real estate portfolio.
                    </p>

                    <div className="flex flex-wrap gap-1.5">
                      <span className="rounded-[6px] bg-[#f4f6f1] px-2 py-1 text-[9px] font-medium text-[#687062]">
                        List Properties
                      </span>
                      <span className="rounded-[6px] bg-[#f4f6f1] px-2 py-1 text-[9px] font-medium text-[#687062]">
                        Manage Clients
                      </span>
                      <span className="rounded-[6px] bg-[#f4f6f1] px-2 py-1 text-[9px] font-medium text-[#687062]">
                        Track Leads
                      </span>
                    </div>
                  </div>
                </div>

                {selectedRole === "owner" && (
                  <div className="absolute bottom-3 right-3 flex h-5 w-5 items-center justify-center rounded-full bg-[#6a7847] text-white shadow-sm">
                    <span className="text-[10px]">✓</span>
                  </div>
                )}
              </button>
            </div>

            <button
              type="button"
              disabled={!selectedRole}
              onClick={handleContinue}
              className={`
                mt-5 flex h-[48px] w-full items-center justify-center gap-1.5
                rounded-[10px] border-none text-[12px] font-semibold transition-all
                ${
                  selectedRole
                    ? "cursor-pointer bg-[linear-gradient(180deg,#6fa142_0%,#4c7a2e_55%,#375c20_100%)] text-white shadow-[0_8px_20px_rgba(76,122,46,0.18)] hover:-translate-y-px hover:shadow-[0_10px_25px_rgba(55,92,32,0.22)]"
                    : "cursor-not-allowed bg-[#e8ebe5] text-[#9da49a]"
                }
              `}
            >
              Continue
              <ArrowRight size={14} />
            </button>

            <div className="mt-5 flex items-center justify-center gap-1 text-[11px] text-[#92968e]">
              <span>Already have an account?</span>

              <button
                type="button"
                onClick={() => navigate("/login")}
                className="border-none bg-transparent p-0 text-[11px] font-semibold text-[#4c7a2e] hover:underline"
              >
                Sign in
              </button>
            </div>

            {/* <div className="mt-6 flex items-center justify-center gap-1.5 text-[9px] text-[#a4a89f]">
              <span className="flex h-4 w-4 items-center justify-center rounded-full border border-[#ccd7c3] text-[#6a7847]">
                ✓
              </span>
              Secure account setup for Terra
            </div> */}
          </div>
        </div>
      </section>
    </main>
  );
};

export default ChooseAccount;
